import { render, staticRenderFns } from "./TalkThreadForm.vue?vue&type=template&id=202e678a&"
import script from "./TalkThreadForm.vue?vue&type=script&lang=ts&"
export * from "./TalkThreadForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports